import React, { useEffect, useState } from 'react';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
import { connect } from 'react-redux';
import { resetBlock, closePopup, setReuse, openPopup } from './bitPaymentSlice';
import PopUp from '../Popup/PopUp';
import ConfirmBitPaymentComponent from './Popups/ConfirmBitPaymentComponent';

import './bitPayment.scss';

const BitPaymentWrapper = (props) => {
  const [confirmBitPayment, setConfirmBitPayment] = useState(false);
  let scriptEl;
  let linkMobile = isAndroid ? props.bit.linkAndroid?.replace(/&amp;/g, '&') : props.bit.linkIphone?.replace(/&amp;/g, '&');
  const currentURL = window.location.href;
  const urlWithoutFragment = currentURL.split('#')[0];
  const baseUrl = urlWithoutFragment.split('?')[0];
  const queryParams = `?externalSystemReference=${props.bit.externalSystemReference}&ban=${props.ban}&amount=${props.paymentAmount}`;

  var encodedString = btoa(queryParams);
  linkMobile = `${linkMobile}%26return_scheme%3D${baseUrl}%3FpaymentData%3D${encodedString}`;

  useEffect(() => {
    if (props.bit.reuse) {
      if (!isMobile) {
        if (scriptEl) {
          pay();
        } else {
          var el = document.createElement('script');
          el.src = 'https://public.bankhapoalim.co.il/bitcom/sdk';
          el.onload = pay;
          document.head.append(el);
          scriptEl = el;
        }
      } else {
        if (linkMobile) {
          setConfirmBitPayment(true);
        }
      }

      setTimeout(() => {
        props.openPopup();
        props.setReuse(false);
      }, 3000);
    }
  }, [props.bit.reuse]);


  function pay() {
    if (BitPayment) {
      BitPayment.pay({
        transactionSerialId: props.bit.transactionSerialId,
        paymentInitiationId: props.bit.paymentInitiationId,
        env: 'Prod',
        onApproved: function (data) {
          props.closePopup();
          props.actionOnPaymentCompleted();
        },
        onCancel: function (data) {
          props.closePopup();
        },
        onTimeout: function (data) {
          props.closePopup();
        },
      });
    }
  }

  function submitPayment() {

    window.open(linkMobile, '_blank');
    setConfirmBitPayment(false);
    props.getActivePaymentStatus();
  }

  return (
    <div className='bit-payment'>
      {isMobile && (
        <PopUp showPopUp={confirmBitPayment} onClose={() => setConfirmBitPayment(false)} className='confirm-bit-payment-popup'>
          <ConfirmBitPaymentComponent submitPayment={submitPayment} />
        </PopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bit: state.bitPayment,
  };
};

const mapDispatchToProps = { resetBlock, closePopup, setReuse, openPopup };

export default connect(mapStateToProps, mapDispatchToProps)(BitPaymentWrapper);
